import { render, staticRenderFns } from "./LeaveHospitalDetail.vue?vue&type=template&id=36f608ac&scoped=true"
import script from "./LeaveHospitalDetail.vue?vue&type=script&lang=js"
export * from "./LeaveHospitalDetail.vue?vue&type=script&lang=js"
import style0 from "./LeaveHospitalDetail.vue?vue&type=style&index=0&id=36f608ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f608ac",
  null
  
)

export default component.exports